module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/logo/affirm-logo-8b5f62d58289e1bd44baa02521f96884.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/logo/affirm-logo.svg
// module id = CzMX
// module chunks = 24